// Book style images
const bookStyles = [
  {
    id: "picture-book-young",
    title: "Picture Book Kids",
    displayTitle: "Picture Book (Young Readers)",
    value: "Picture Book",
    description: "Colorful illustrations with simple text for young readers",
    image: "/styles/book/picture-book-kids.jpeg",
    wordsPerPage: 50,
    disabled: false,
  },
  {
    id: "picture-book-teen",
    title: "Picture Book Teens",
    value: "Picture Book",
    displayTitle: "Picture Book (Teen Readers)",
    description: "More complex illustrations and text for teen readers",
    image: "/styles/book/picture-book-teens.jpeg",
    wordsPerPage: 150,
    disabled: false,
  },
  {
    id: "chapter-book",
    title: "Chapter Book",
    displayTitle: "Chapter Book (Coming Soon)",
    description:
      "Text-focused with occasional illustrations for independent readers",
    image: "/styles/book/chapter-book.jpeg",
    disabled: true,
  },
  {
    id: "graphic-novel",
    title: "Graphic Novel",
    displayTitle: "Graphic Novel (Coming Soon)",
    description: "Sequential art with dialogue and narration",
    image: "/styles/book/graphic-novel.jpeg",
    disabled: true,
  },
];

const visualStyles = [
  {
    id: "childrens-book",
    title: "Children's Book",
    value: "Children's Book",
    description: "Classic children's book illustration style",
    image: "/styles/visual/childrens-book.jpeg",
  },
  {
    id: "3d-animation",
    title: "3D Animation",
    value: "Pixar 3D",
    description: "High-quality 3D animation in Pixar style",
    image: "/styles/visual/3d-animation.jpeg",
  },
  {
    id: "pop-art",
    title: "PopArt",
    value: "PopArt Simplistic",
    description: "Bold, vibrant pop art style",
    image: "/styles/visual/pop-art.jpeg",
  },
  {
    id: "stick-art",
    title: "Stick Art",
    value: "Stick Art",
    description: "Simple stick figure style",
    image: "/styles/visual/stickArt.webp",
  },
  {
    id: "digital-scifi",
    title: "Digital SciFi Art",
    value: "Digital SciFi Art",
    description: "Futuristic digital sci-fi artwork",
    image: "/styles/visual/digital-scifi.jpeg",
  },
  {
    id: "claymation",
    title: "Claymation",
    value: "Everything made with clay, Claymation with less details",
    description: "Charming clay animation style",
    image: "/styles/visual/claymation.jpeg",
  },
  {
    id: "watercolor",
    title: "Watercolor",
    value: "Watercolor Simple",
    description: "Soft and dreamy watercolor paintings",
    image: "/styles/visual/watercolor.jpeg",
  }
];

const writingStyles = [
  {
    id: "adventure-narrative",
    title: "Adventure Narrative",
    value: "Adventure Narrative",
    description: "Exciting storytelling with action and discovery",
    image: "/styles/writing/adventure.jpeg",
  },
  {
    id: "rhyming-story",
    title: "Rhyming Story",
    value: "Rhyming Story",
    description: "Fun and engaging rhyming patterns throughout the story",
    image: "/styles/writing/rhyming.png",
  },
  {
    id: "poetic-prose",
    title: "Poetic Prose",
    value: "Poetic Prose",
    description: "Lyrical and flowing narrative style",
    image: "/styles/writing/poetic.jpeg",
  },
  {
    id: "diary-format",
    title: "Diary or Journal Format",
    value: "Diary or Journal Format",
    description: "Personal and intimate diary-style storytelling",
    image: "/styles/writing/diary.jpeg",
  },
  {
    id: "educational",
    title: "Educational",
    value: "Educational",
    description: "Learning-focused content with clear explanations",
    image: "/styles/writing/educational.jpeg",
  },
  {
    id: "whimsical",
    title: "Whimsical",
    value: "Whimsical",
    description: "Playful and imaginative storytelling style",
    image: "/styles/writing/whimsical.jpeg",
  }
];

export { bookStyles, visualStyles, writingStyles };
